import React from 'react'
import { useAuth } from '../contexts/authContext'
import { useNavigate } from 'react-router-dom'
import { menus } from './menus'
import { PiCirclesFour } from 'react-icons/pi'
import { FaRegFileAlt } from 'react-icons/fa'
import { GrGroup } from 'react-icons/gr'
import { LuUserRound } from 'react-icons/lu'
import { MdLogout } from "react-icons/md";

interface SidebarProps {
  className?: string
  currentPath?: string
}

const Sidebar: React.FC<SidebarProps> = ({ className = '', currentPath = '' }) => {
  const { logout } = useAuth()
  const navigate = useNavigate()

  const icons = {
    'rich-menu': React.createElement(PiCirclesFour as any, { className: "w-5 h-5" }),   
    'tracking-log': React.createElement(FaRegFileAlt as any, { className: "w-5 h-5" }),
    'pc-segment': React.createElement(GrGroup as any, { className: "w-5 h-5" }),
    'user-management': React.createElement(LuUserRound as any, { className: "w-5 h-5" }),
  }

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <aside className={`fixed top-16 left-0 bottom-0 w-64 bg-white shadow-lg flex flex-col ${className}`}>
      <nav className="p-4 flex-1">
        <ul className="space-y-2">
          {menus.map((item) => {
            const isActive = currentPath === item.path
            return (
              <li key={item.key}>
                <a
                  href={item.path}
                  className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${isActive
                    ? 'text-gray-700 bg-gray-100'
                    : 'text-gray-600 hover:bg-gray-50'
                    }`}
                >
                  {icons[item.key as keyof typeof icons]}
                  <span className={isActive ? 'font-medium' : ''}>{item.name}</span>
                </a>
              </li>
            )
          })}
        </ul>
      </nav>
      <div className="p-4">
        <button
          onClick={handleLogout}
          className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors"
        >
          {React.createElement(MdLogout as any, { className: "w-5 h-5" })}
          <span>Logout</span>
        </button>
      </div>
    </aside>
  )
}

export default Sidebar
